import { render, staticRenderFns } from "./ATMSettings.vue?vue&type=template&id=2869fc37"
import script from "./ATMSettings.vue?vue&type=script&lang=ts"
export * from "./ATMSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports